export const equipment = {
    legacyId: '', // not render in form
    account: '',
    client: '',
    site: '',
    code: '',
    brand: '', // receive 3 values: 'ZOOY', 'JWM', 'OTHER',
    type: '', // received 2 values: 'DEVICE-READER' or 'EQUIPMENT-SENSOR'
    user: '',
    status: 'ACTIVE', // not render in form, just in table list
    hasImport: true, // not render in form
    createDate: '', // not render in form
    updateDate: '', // not render in form
    companyLegacyParentId: '', // not render in form
}
